/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationStatus;

(function (ValidationStatus) {
  ValidationStatus["IMPORTED"] = "imported";
  ValidationStatus["NOT_STARTED"] = "not_started";
  ValidationStatus["INVITATION_CREATED"] = "invitation_created";
  ValidationStatus["DROPOUT"] = "dropout";
  ValidationStatus["CANCELLED"] = "cancelled";
  ValidationStatus["IN_PROGRESS"] = "in_progress";
  ValidationStatus["FAIL"] = "fail";
  ValidationStatus["SUCCESS"] = "success";
  ValidationStatus["PAYE_CONTRACTOR"] = "paye_contractor";
  ValidationStatus["EXPIRED"] = "expired";
  ValidationStatus["EXPIRE_SOON"] = "expire_soon";
  ValidationStatus["URGENT_EXPIRING"] = "urgent_expiring";
  ValidationStatus["PENDING"] = "pending";
})(ValidationStatus || (ValidationStatus = {}));

export var ValidationState;
/**
 * Model for 'validation' database table
 */

(function (ValidationState) {
  ValidationState["SUCCESS"] = "success";
  ValidationState["PENDING"] = "pending";
  ValidationState["FAIL"] = "fail";
})(ValidationState || (ValidationState = {}));